module.exports = __webpack_public_path__ + "img/Students in home ec kitchen, 1950s-60s.89d86619.jpg";